export default __webpack_public_path__ + "static/media/exterior4.573edf12.webp";